module.exports = __webpack_public_path__ + "img/maintaining.a94d9176.svg";